import { render, staticRenderFns } from "./BtnMsgCancelamento.vue?vue&type=template&id=634ea9c8"
import script from "./BtnMsgCancelamento.vue?vue&type=script&lang=js"
export * from "./BtnMsgCancelamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports